import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const cloneDraftReturnExcludingItems = {
  name: "cloneDraftReturnExcludingItems" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    excludedReturnableItemIds: z.array(z.string()),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
